module.exports = __webpack_public_path__ + "img/37782-014.05734be4.jpg";